import * as types from "../actions/ActionTypes";
import ErrorCodeHelper from "../utilities/ErrorCodeHelper";
import { getErrorMessage } from "../utilities/ErrorMessageHelper";
import UrlHelper from "../utilities/UrlHelper";
import { mapVirtualUserSecurityPolicyToSettings } from "../entities/PasswordValidationSettings";
import PasswordValidationUserData from "newApp/entities/PasswordValidationUserData";

export const getInitialState = () => (
    {
        email: undefined,
        errorMessage: undefined,
        redirectLocationOnSuccess: undefined,
        redirectLocationOnError: undefined,
        passwordValidationUserData: undefined,
        passwordRequirements: undefined,
        pin: undefined,
        pinValidated: undefined,
        errorCode: undefined,
        isPasswordSetting: false
    });

const SetPasswordReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.VALIDATE_TICKET_SUCCEEDED: {
        return Object.assign({}, state, {
            email: action.response.Email,
            errorMessage: undefined,
            pinValidated: action.response.IsVirtualUserVerified,
            passwordRequirements: mapVirtualUserSecurityPolicyToSettings(action.response.PasswordSettings),
            passwordValidationUserData: new PasswordValidationUserData(action.response.PasswordValidationUserData) });
    }
    case types.VALIDATE_TICKET_FAILED: {
        return Object.assign({}, state, { email: undefined, errorMessage: getErrorMessage(action.error) });
    }
    case types.SET_PASSWORD_SUCCEEDED:
    case types.RESET_VIRTUAL_USER_PASSWORD_SUCCEEDED:
    case types.UPGRADE_TO_VIRTUAL_USER_SUCCEEDED: {
        return Object.assign({}, state, { redirectLocationOnSuccess: action.url, errorMessage: undefined, isPasswordSetting: false });
    }
    case types.SET_PASSWORD_FAILED: {
        return ErrorCodeHelper.isTicketExpiredError(action.error)
            ? Object.assign({}, state, { redirectLocationOnError: UrlHelper.getSetPasswordTicketExpiredUrl(), isPasswordSetting: false })
            : Object.assign({}, state, { errorMessage: getErrorMessage(action.error), isPasswordSetting: false });
    }
    case types.RESET_VIRTUAL_USER_PASSWORD_FAILED: {
        return ErrorCodeHelper.isTicketExpiredError(action.error)
            ? Object.assign({}, state, { redirectLocationOnError: UrlHelper.getResetPasswordTicketExpiredUrl(), isPasswordSetting: false })
            : Object.assign({}, state, { errorMessage: getErrorMessage(action.error), isPasswordSetting: false });
    }
    case types.UPGRADE_TO_VIRTUAL_USER_FAILED: {
        return ErrorCodeHelper.isTicketExpiredError(action.error)
            ? Object.assign({}, state, { redirectLocationOnError: UrlHelper.getUpgradeToVirtualUserTicketExpiredUrl(), isPasswordSetting: false })
            : Object.assign({}, state, { errorMessage: getErrorMessage(action.error), isPasswordSetting: false });
    }
    case types.SET_RESET_PASSWORD_STARTED: {
        return Object.assign({}, state, { isPasswordSetting: true });
    }
    case types.PIN_VALIDATED_SUCCEEDED:{
        return Object.assign({}, state, { pin: action.pin, pinValidated: true, errorMessage: undefined });
    }
    case types.PIN_VALIDATED_FAILED: {
        if(ErrorCodeHelper.isInvalidPin(action.error)) {
            return Object.assign({}, state, {
                pinValidated: undefined,
                errorMessage: getErrorMessage(action.error),
                errorCode: "Incorrect PIN" });
        }
        if(ErrorCodeHelper.isUserLocked(action.error)) {
            return Object.assign({}, state, {
                pinValidated: undefined,
                errorMessage: getErrorMessage(action.error),
                errorCode: "Account Locked" });
        }
        return state;
    }
    default:
        return state;
    }
};

export default SetPasswordReducer;
